import {RestAPI} from './proxies';

const cache = {};

export const getProfile = async () => {
    if (cache['profile'] !== undefined) {
        const cacheTimestamp = cache['profile']['ts'];
        const now = Date.now();
        if (now < cacheTimestamp + 60 * 1000) {
            return cache['profile']['data'];
        }
    }
    const response = await RestAPI.get('/api/profile');
    if (response.success) {
        cache['profile'] = {
            data: response['data']['profile'],
            ts: Date.now(),
        }
        return cache['profile']['data'];
    } else if ((response.success === false) && (response.errorCode === 'NotLoggedIn')) {
        return {};
    } else {
        throw new Error(`Failed to get profile`);
    }
};

export const isLoggedIn = async () => {
    return (document.cookie.match(/xUser/) !== null);
};

export const getOTP = async function(email) {
    return await RestAPI.post('/api/getotp', {'email': email});
};

export const validateOTP = async function(email, otp) {
    const data = await RestAPI.post('/api/validateotp', {'email': email, 'otp': otp});
    if (data.success) {
        document.cookie = `xUser=${data.data.xUser};max-age=${60*60*24*365*3};SameSite=Strict`;
        getProfile();
    }
    return data;
};

export const signOut = () => {
    document.cookie = 'xUser=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;SameSite=Strict';
};